var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-danger font-heading font-medium text-sm text-left mt-1"},[_vm._v(" "+_vm._s(_vm.error)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }